
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { TaskFormData } from "@/types/task";
import type { Employee } from "@/types/employee";
import type { Client } from "@/types/client";
import type { Company } from "@/types/company";
import type { Supplier } from "@/types/supplier";

interface Props {
  formData: TaskFormData;
  setFormData: (data: TaskFormData) => void;
  employees: Employee[];
  clients: Client[];
  companies: Company[];
  suppliers: Supplier[];
}

export const TaskFormAssignments = ({ formData, setFormData, employees, clients, companies, suppliers }: Props) => (
  <>
    {employees.length > 0 && (
      <div className="space-y-2">
        <Label htmlFor="assigned_to">مُخصص إلى</Label>
        <Select value={formData.assigned_to} onValueChange={(value) => setFormData({ ...formData, assigned_to: value })}>
          <SelectTrigger>
            <SelectValue placeholder="اختر الموظف" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="null">-- غير مخصص --</SelectItem>
            {employees.map((employee) => (
              <SelectItem key={employee.id} value={employee.id}>
                {employee.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    )}

    {(formData.type === 'client' || formData.type.includes('عميل')) && clients.length > 0 && (
      <div className="space-y-2">
        <Label htmlFor="client_id">العميل</Label>
        <Select value={formData.client_id} onValueChange={(value) => setFormData({ ...formData, client_id: value })}>
          <SelectTrigger>
            <SelectValue placeholder="اختر العميل" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="null">-- بدون عميل --</SelectItem>
            {clients.map((client) => (
              <SelectItem key={client.id} value={client.id}>
                {client.name_ar}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    )}

    {(formData.type === 'supplier' || formData.type.includes('مورد')) && suppliers.length > 0 && (
      <div className="space-y-2">
        <Label htmlFor="supplier_id">المورد</Label>
        <Select value={formData.supplier_id} onValueChange={(value) => setFormData({ ...formData, supplier_id: value })}>
          <SelectTrigger>
            <SelectValue placeholder="اختر المورد" />
          </SelectTrigger>
          <SelectContent>
              <SelectItem value="null">-- بدون مورد --</SelectItem>
            {suppliers.map((supplier) => (
              <SelectItem key={supplier.id} value={supplier.id}>
                {supplier.name_ar}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    )}

    {companies.length > 0 && (
      <div className="space-y-2">
        <Label htmlFor="company_id">الشركة</Label>
        <Select value={formData.company_id} onValueChange={(value) => setFormData({ ...formData, company_id: value })}>
          <SelectTrigger>
            <SelectValue placeholder="اختر الشركة" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="null">-- بدون شركة --</SelectItem>
            {companies.map((company) => (
              <SelectItem key={company.id} value={company.id}>
                {company.name_ar}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    )}
  </>
);
